
export class Examen {
    type_examen_id:any=null;
    type_examen_etat:String;
    type_examen_libelle:String;
    type_examen_lieu:String;    
    examen_id :number;
	examen_etat  : String;
	examen_resultats : String; 
	examen_description : String;
	examen_renseignement_clinique : String;
	examen_validation : String;
	examen_date_envoie : Date; 
	examen_resultat_image : any;
	examen_date_realisation : Date; 
	examen_lieu_etablissement : String; 
	examen_heure_realisation : String; 
	examen_date_retour_médecien : Date;
	id_type_examen : String;
	employer_id : number;
	id_consultation : number;
    constructor($type_examen_id:any, $type_examen_libelle:String){
        this.type_examen_id=$type_examen_id;
        this.type_examen_libelle=$type_examen_libelle;
    }
}
